import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';
const initialStateInstallerPayment = {
    InstallerPayment: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getInstallerPayment = createAsyncThunk(
    'installerPayment/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllInstallerPayment', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.accounts);
            return response.data.installerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const createInstallerPayment = createAsyncThunk(
    'installerPayment/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createInstallerPayment', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data);
            dispatch(getInstallerPayment());
            return response.data.installerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteInstallerPayment = createAsyncThunk(
    'installerPayment/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteInstallerPayment/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getInstallerPaymentById = createAsyncThunk(
    'installerPayment/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getInstallerPaymentById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.installerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateInstallerPayment = createAsyncThunk(
    'installerPayment/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("id", data);
        try {
            const response = await axiosInstance.put(`${BASE_URL}/updateInstallerPayment/${data._id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getInstallerPayment());
            // console.log("Update ID :", response.data);
            return response.data.installerPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllInstallerData = createAsyncThunk(
    'installerPayment/getAllInstallerData',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllInstallerData', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.assignInstaller;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllDataFabricator = createAsyncThunk(
    'installerPayment/getAllDataFabricator',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDataFabricator', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.fabricator;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllDataElectrician = createAsyncThunk(
    'installerPayment/getAllDataElectrician',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDataElectrician', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.electrician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllDataTechnician = createAsyncThunk(
    'installerPayment/getAllDataTechnician',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDataTechnician', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const InstallerPaymentSlice = createSlice({
    name: 'installerPayment',
    initialState: initialStateInstallerPayment,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getInstallerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Installer Payment...';
            })
            .addCase(getInstallerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Installer Payment fetched successfully';
                state.InstallerPayment = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getInstallerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Installer Payment';
            })
            .addCase(createInstallerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Installer...';
            })
            .addCase(createInstallerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.InstallerPayment.push(action.payload);
                state.message = action.payload?.message || 'Installer Payment added successfully';
            })
            .addCase(createInstallerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Installer Payment';
            })
            .addCase(deleteInstallerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Installer Payment...';
            })
            .addCase(deleteInstallerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.InstallerPayment = state.InstallerPayment.filter((user) => user._id !== action.payload);
                state.message = action.payload?.message || 'Installer Payment deleted successfully';
            })
            .addCase(deleteInstallerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Installer Payment';
            })
            .addCase(updateInstallerPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Installer Payment...';
            })
            .addCase(updateInstallerPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.InstallerPayment)) {
                    state.InstallerPayment = state.InstallerPayment.map(d =>
                        d._id === action.payload?._id ? action.payload : d
                    );
                }
                state.message = 'Installer Payment updated successfully';
            })
            .addCase(updateInstallerPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Installer Payment';
            })
            .addCase(getAllInstallerData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Installer Data...';
            })
            .addCase(getAllInstallerData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Installer Data fetched successfully';
                state.assignInstaller = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAllInstallerData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Installer Data';
            })
            .addCase(getAllDataFabricator.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricator Data...';
            })
            .addCase(getAllDataFabricator.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricator Data fetched successfully';
                state.fabricator = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAllDataFabricator.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricator Data';
            })
            .addCase(getAllDataElectrician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Electrician Data...';
            })
            .addCase(getAllDataElectrician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Electrician Data fetched successfully';
                state.electrician = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAllDataElectrician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Electrician Data';
            })
            .addCase(getAllDataTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Technician Data...';
            })
            .addCase(getAllDataTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Technician Data fetched successfully';
                state.technician = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getAllDataTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Technician Data';
            })
    }
});


export default InstallerPaymentSlice.reducer;